module.exports = __webpack_public_path__ + "static/img/avatar-man.e10dec52.png";